import { z } from 'zod'
import { IataSchema } from '../platformConfig'

// Locales enabled in contentful instance
export const ContentfulLocaleSchema = z.enum(['en-US', 'es-ES'])

export type ContentfulLocale = z.infer<typeof ContentfulLocaleSchema>

const ContentfulRewardPlatformApplication = z.literal('reward_platform')

export const ContentfulEntriesRequestParamsSchema = z.object({
  opCo: IataSchema,
  locale: z.string().min(2).max(5),
  market: z.string().min(2).max(2).optional(),
  preview: z.coerce.boolean().optional(),
  /** used to filter entries from other applications
   * when models are shared within the contentful space */
  application: ContentfulRewardPlatformApplication.optional(),
})

export type ContentfulEntriesRequestParams = z.infer<typeof ContentfulEntriesRequestParamsSchema>

export const ContentfulEntryRequestParamsSchema = ContentfulEntriesRequestParamsSchema.extend({
  identifier: z.string(),
})

export type ContentfulEntryRequestParams = z.infer<typeof ContentfulEntryRequestParamsSchema>
